export default __webpack_public_path__ + "static/media/ArrowNext.f63d49a8.webp";